import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#fff\" d=\"M2 1h13v14H2z\"></path><path fill=\"#0A66C2\" d=\"M15.319 0H1.68A1.18 1.18 0 0 0 .5 1.181V14.82A1.18 1.18 0 0 0 1.681 16H15.32a1.18 1.18 0 0 0 1.181-1.181V1.18A1.18 1.18 0 0 0 15.319 0M5.269 13.63H2.863V5.989H5.27zm-1.205-8.7a1.381 1.381 0 1 1 1.39-1.38 1.36 1.36 0 0 1-1.39 1.38m10.072 8.707H11.73V9.462c0-1.23-.523-1.61-1.199-1.61-.713 0-1.413.537-1.413 1.641v4.144H6.713V5.994h2.314v1.06h.03c.233-.47 1.046-1.274 2.287-1.274 1.343 0 2.793.797 2.793 3.13z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M.5 0h16v16H.5z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }